import { classInstance } from '@/shared/helpers/helpers';
import {vars} from '@/app/config/variables.js';

const draw = (input, placeholder, position) => input.placeholder = placeholder.slice(0, position);

const getPlaceholder = () => window.matchMedia('(min-width: 1280px)').matches ? 'Введите фразу для поиска, поиск среди 150 000 товаров!' : 'Введите фразу для поиска';

const animateSearch = (input) => {
	const fpsInterval = 50;
	let now;
	let then = Date.now();
	let elapsed;
	let position = 0;

	const placeholder = getPlaceholder();

	const tick = () => {
		requestAnimationFrame(tick);
		now = Date.now();
		elapsed = now - then;
		if (elapsed > fpsInterval) {
			then = now - (elapsed % fpsInterval);
			if (position <= placeholder.length) {
				draw(input, placeholder, position);
				position += 1;
			}
			else cancelAnimationFrame(tick);
		}
	};
	requestAnimationFrame(tick);
};

export class HeaderSearch {
	placeholderSet = false;
	media = window.matchMedia(`(min-width: ${vars.breakpoint.desktopSmall}px)`);
	opener = document.querySelector('.header-mobile__button--search');
	menuOpener = document.querySelector('.header-mobile__button--burger');

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.input = this.element.querySelector('.form-input');
		this.submit = this.element.querySelector('.header-search__submit');
		this.reset = this.element.querySelector('.header-search__reset');
		this.close = this.element.querySelector('.header-search__close');
		this.history = this.element.querySelector('.header-search__history');
		this.result = this.element.querySelector('.header-search__result');
		this.historyReset = this.element.querySelector('.header-search__history-reset');
		this.back = this.element.querySelector('.header-search__back');

		this.init();
	}

	setPlaceholder = () => {
		if (this.media.matches && !this.placeholderSet) {
			animateSearch(this.input);
			this.placeholderSet = true;
		}
		else this.input.placeholder = getPlaceholder();
	};

	checkHistoryItems = () => {
		const itemElements = this.history.querySelectorAll('.header-search__history-item');

		if (itemElements.length !== 0) this.history.classList.add('header-search__history--visible');
		else this.history.classList.remove('header-search__history--visible');
	};

	resetSearch = () => {
		this.reset.classList.remove('header-search__reset--visible');
		this.submit.disabled = true;
		this.result.classList.remove('header-search__result--visible');
	};

	openResult = () => {
		this.reset.classList.add('header-search__reset--visible');
		this.submit.disabled = false;
		this.history.classList.remove('header-search__history--visible');
		this.result.classList.add('header-search__result--visible');
	};

	onSearchOpenClick = () => {
		document.body.classList.add('disable-scroll');
		this.element.classList.add('header-search--visible');
		this.input.focus();
		this.checkHistoryItems();
	};

	onSearchCloseClick = () => {
		this.element.classList.remove('header-search--visible');
		this.history.classList.remove('header-search__history--visible');
		this.resetSearch();

		if (this.menuOpener.getAttribute('aria-expanded') === 'false') document.body.classList.remove('disable-scroll');
	};

	onSearchResetClick = () => {
		this.resetSearch();
		this.checkHistoryItems();
		this.element.focus();
	};

	onSearchHistoryResetClick = () => {
		const itemElements = this.history.querySelectorAll('.header-search__history-item');

		itemElements.forEach((element) => element.remove());
		this.history.classList.remove('header-search__history--visible');
		this.input.focus();
	};

	onSearchHistoryClick = ({ target }) => {
		if (target.classList.contains('header-search__history-remove')) {
			target.parentElement.remove();
			this.checkHistoryItems();
			this.input.focus();
		}

		if (target.classList.contains('header-search__history-element')) {
			const value = target.querySelector('span').textContent;
			this.openResult();
			this.input.value = value;
			this.input.focus();
		}
	};

	onSearchInputFocus = () => {
		if (window.matchMedia('(min-width: 1280px)').matches) {
			this.back.classList.add('header-search__back--visible');
			if (!this.result.classList.contains('header-search__result--visible')) this.checkHistoryItems();
		}
		if (this.input.value) this.input.dispatchEvent(new Event('input'));
	};

	onSearchBackClick = () => {
		this.back.classList.remove('header-search__back--visible');
		this.close.click();
	};

	init = () => {
		classInstance.set(this.element, this);
		this.setPlaceholder();
		this.media.addEventListener('change', this.setPlaceholder);
		this.opener.addEventListener('click', this.onSearchOpenClick);
		this.close.addEventListener('click', this.onSearchCloseClick);
		this.reset.addEventListener('click', this.onSearchResetClick);
		this.historyReset.addEventListener('click', this.onSearchHistoryResetClick);
		this.history.addEventListener('click', this.onSearchHistoryClick);
		this.input.addEventListener('focus', this.onSearchInputFocus);
		this.back.addEventListener('click', this.onSearchBackClick);
	};
}
